import logger from '@/helpers/LoggerHelper';

(globalThis as typeof globalThis & { logger: typeof logger }).logger = logger;
